import React, { useEffect, useState, useMemo } from "react";
import { SERVER_URL } from "../config";
import axios from "axios";
import TableHeaderFilter from "../components/TableHeaderfilter";
import SearchableDropdown from "../components/SearchableDropdown";
import { XMarkIcon, ArrowLeftIcon } from "@heroicons/react/24/outline";

const GoldUserModal = ({ open, onClose }) => {
  const [users, setUsers] = useState([]);
  const [selectedUser, setSelectedUser] = useState(null);
  const [businessOptions, setBusinessOptions] = useState([]);

  const [filters, setFilters] = useState({
    tallySlNo: [],
    customerName: [],
    contactPerson: [],
    userType: [],
    bussinessType: [],
    release: [],
    updatedBy: [], // ✅ added
  });

  // ✅ Columns to show in TABLE only
  const tableColumns = [
    "slNo",
    "tallySlNo",
    "customerName",
    "contactPerson",
    "contactNumber",
    "expireDate",
    "updatedAt",   // ✅ added
    "updatedBy",   // ✅ added
  ];

  const fetchUsers = async () => {
    try {
      const res = await axios.get(`${SERVER_URL}/Rahul/fetchGoldUserAndCustomerDetails.php`);
      if (res.data.status) setUsers(res.data.data);
    } catch (err) {
      console.error(err);
    }
  };

  const fetchBusinessTypes = async () => {
    try {
      const res = await axios.get(`${SERVER_URL}/Rahul/getBusinessTypes.php`);
      if (res.data.status) {
        setBusinessOptions(
          res.data.data.map((b) => ({ label: b.name, value: b.name }))
        );
      }
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    if (open) {
      fetchUsers();
      fetchBusinessTypes();
    }
  }, [open]);

  const getOptions = (key) => {
    const unique = [...new Set(users.map((u) => u[key]).filter(Boolean))];
    return unique.map((val) => ({ label: val, value: val }));
  };

  const filteredUsers = useMemo(() => {
    return users.filter((u) =>
      Object.keys(filters).every((key) =>
        filters[key].length === 0 ? true : filters[key].includes(u[key])
      )
    );
  }, [users, filters]);

  const handleChange = (key, value) => {
    setSelectedUser((prev) => ({ ...prev, [key]: value }));
  };

  const handleCancel = () => setSelectedUser(null);

  const handleUpdateSubmit = async () => {
    try {
      const employee = JSON.parse(localStorage.getItem("employee"));

      const payload = {
        ...selectedUser,
        updatedBy: `${employee?.employee_id} - ${employee?.employee_name}`
      };

      await axios.post(
        `${SERVER_URL}/Rahul/updateGoldUserAndCustomerDetails.php`,
        payload
      );

      fetchUsers();
      setSelectedUser(null);
    } catch (err) {
      console.error(err);
    }
  };

  if (!open) return null;

  const filterableColumns = [
    "tallySlNo",
    "customerName",
    "contactPerson",
    "userType",
    "bussinessType",
    "release",
    "updatedBy", // ✅ added
  ];

  // ✅ remarks added
  const editableFields = [
    "numberOfEmployees",
    "numberOfBranch",
    "numberOfTallyUser",
    "remark",
  ];

  return (
    <>
      <style>{`
        .att-scrollbar::-webkit-scrollbar { width: 5px; height: 5px; }
        .att-scrollbar::-webkit-scrollbar-track { background: #f1f5f9; border-radius: 10px; }
        .att-scrollbar::-webkit-scrollbar-thumb { background: #cbd5e1; border-radius: 10px; }
        .att-scrollbar::-webkit-scrollbar-thumb:hover { background: #94a3b8; }
      `}</style>

      {/* Backdrop */}
      <div
        className="fixed inset-0 z-[9999] flex items-center justify-center"
        style={{
          background: "rgba(15,23,42,0.45)",
          backdropFilter: "blur(6px)",
        }}
      >
        {/* Modal */}
        <div className="w-[95%] max-w-[1400px] h-[90vh] rounded-2xl bg-white border border-slate-200 flex flex-col overflow-hidden">

          {/* HEADER */}
          <div className="flex-shrink-0 flex items-center justify-between px-6 py-4 border-b border-slate-200 bg-slate-50">
            <div className="flex items-center gap-3">
              {selectedUser && (
                <button
                  onClick={handleCancel}
                  className="p-1.5 rounded-lg text-slate-500 hover:bg-slate-200"
                >
                  <ArrowLeftIcon className="w-5 h-5" />
                </button>
              )}
              <h2 className="text-lg font-bold text-slate-800">
                {selectedUser
                  ? `Update User — SL: ${selectedUser.slNo}`
                  : "Gold Users"}
              </h2>
            </div>

            <button onClick={() => (selectedUser ? setSelectedUser(null) : onClose())}>
              <XMarkIcon className="w-6 h-6 text-slate-400" />
            </button>
          </div>

          {/* TABLE */}
          {!selectedUser && (
            <div className="flex-1 overflow-auto">
              <table className="min-w-full border-collapse">
                <thead className="sticky top-0 bg-slate-50">
                  <tr>
                    {tableColumns.map((col) => (
                      <th key={col} className="p-3 border text-left text-xs text-slate-500">
                        {filterableColumns.includes(col) ? (
                          <TableHeaderFilter
                            label={
                              col === "updatedAt"
                                ? "Update Date"
                                : col === "updatedBy"
                                  ? "Update By"
                                  : col
                            }
                            options={getOptions(col)}
                            selectedValues={filters[col] || []}
                            onChange={(vals) =>
                              setFilters((prev) => ({ ...prev, [col]: vals }))
                            }
                          />
                        ) : (
                          col
                        )}
                      </th>
                    ))}
                    <th className="p-3 border text-xs text-slate-500">Action</th>
                  </tr>
                </thead>

                <tbody>
                  {filteredUsers.map((u) => (
                    <tr key={u.slNo} className="border-t hover:bg-blue-50">
                      {tableColumns.map((key) => (
                        <td key={key} className="p-3 text-xs text-slate-600">
                          {key === "updatedAt" && u[key]
                            ? new Date(u[key]).toLocaleString("en-IN")
                            : u[key] ?? "-"}
                        </td>
                      ))}
                      <td className="p-3">
                        <button
                          onClick={() => setSelectedUser(u)}
                          className="px-3 py-1 text-xs text-white bg-green-500 rounded"
                        >
                          Update
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}

          {/* FORM */}
          {selectedUser && (
            <div className="flex-1 overflow-auto p-6 bg-slate-50">
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">

                {Object.keys(selectedUser)
                  .filter((key) => key !== "is_update")
                  .map((key) => {
                    if (key === "slNo") return null;

                    if (key === "bussinessType") {
                      return (
                        <div key={key}>
                          <label className="text-xs font-semibold">{key}</label>
                          <SearchableDropdown
                            options={businessOptions}
                            value={selectedUser[key]}
                            onChange={(val) => handleChange(key, val)}
                          />
                        </div>
                      );
                    }

                    const isEditable = editableFields.includes(key);

                    return (
                      <div key={key}>
                        <label className="text-xs font-semibold">{key}</label>
                        <input
                          value={selectedUser[key] || ""}
                          onChange={(e) => handleChange(key, e.target.value)}
                          readOnly={!isEditable}
                          className={`w-full border p-2 rounded ${isEditable ? "bg-white" : "bg-gray-100"
                            }`}
                        />
                      </div>
                    );
                  })}
              </div>

              <div className="mt-6 flex gap-3">
                <button
                  onClick={handleUpdateSubmit}
                  className="px-5 py-2 bg-blue-600 text-white rounded"
                >
                  Update
                </button>

                <button
                  onClick={handleCancel}
                  className="px-5 py-2 border rounded"
                >
                  Cancel
                </button>
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default GoldUserModal;